import { SUPPORT_EMAIL } from '@psyomics/ui-common';
import { Trans, useTranslation } from 'react-i18next';

import { cn } from '../../../shadcn/lib/utils';
import { Header } from '../../atoms/header/header';
import { Illustration } from '../../atoms/illustration/illustration';
import { Text } from '../../atoms/text/text';

type GenericErrorProps = {
  readonly className?: string;
  readonly titleKey?: string;
  readonly subtitleKey?: string;
  readonly titleComponents?: Record<string, React.ReactElement>;
};

const DEFAULT_TITLE_KEY = 'ui-components.genericError.title';
const DEFAULT_SUBTITLE_KEY = 'ui-components.genericError.subtitle';

function GenericError({
  className,
  titleKey = DEFAULT_TITLE_KEY,
  titleComponents,
  subtitleKey = DEFAULT_SUBTITLE_KEY,
}: GenericErrorProps) {
  const { t } = useTranslation();

  const titleNode = titleComponents ? <Trans components={titleComponents} i18nKey={titleKey} /> : t(titleKey);

  return (
    <div
      className={cn('mx-auto flex items-center justify-between gap-4 flex-col max-w-[414px] align-middle', className)}
    >
      <div>{<Illustration height={300} name={'SoftwareTester'} width={300} />}</div>
      <Header className="text-center" level="h1">
        {titleNode}
      </Header>
      <Text className={'text-center'} size="lg" tag="p">
        <Trans
          components={{
            linkTag: (
              <a className="text-blue-500 underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            ),
          }}
          i18nKey={subtitleKey}
        />
      </Text>
    </div>
  );
}

GenericError.displayName = 'GenericError';

export { GenericError };
